/* eslint-disable */
import { locales } from '../translations/locales';
import { ModuleRP } from '../components/ModRP';
import translateEntries from './translateEntries';

export default class Radio {
    constructor(locale, userId, vehicle) {
        this.on = false;
        this.alarmOn = false;
        this.messageOn = false;
        this.userId = userId;
        this.vehicle = vehicle;
        this.connect = false;
        this.locale = locale;
        this.listeners = []; // Pour stocker les listeners
        this.sounds = {
            start: new Audio('/sounds/start_radio.ogg'),
            bipClavier: new Audio('/sounds/bip_radio.ogg'),
            acquit: new Audio('/sounds/acquit2.ogg'),
            acquit_retour: new Audio('/sounds/acquit1.ogg'),
            reception: new Audio('/sounds/reception.ogg'),
        }
        this.sounds.start.volume = 0.5;
        this.sounds.bipClavier.volume = 0.1;
        this.sounds.acquit.volume = 0.1;
        this.sounds.acquit_retour.volume = 0.1;
        this.sounds.reception.volume = 0.1;
        this.message = '';
        this.n_selection = 1;
        this.menuSelection = false;
        this.waitForAcknowledge = false;
        this.testNumericButtonForStatus = false;
        this.status = {};
    };

    addListener(listener) {
        this.listeners.push(listener);
    };

    notifyListeners() {
        this.listeners.forEach((listener) => listener(this));
    };

    pressButton = (button) => {
        if (this.on) {
            this.sounds.bipClavier.play();
        }
        if (button !== 'vert' && !this.on) return;
        switch (button) {
            case 'rouge':
                if (this.on) {
                    this.sounds.start.play();
                    this.on = false;
                    this.message = '';
                }
                break;
            case 'vert':
                if (!this.on) {
                    this.allumer();
                }
                break;
            case 'centre':
                if (this.waitForAcknowledge) this.acknowledge(false);
                this.loadStatus();
                break;
            case '^':
                if (this.menuSelection) {
                    if (this.n_selection > 1) {
                        this.n_selection--;
                    }
                }
                break;
            case 'v':
                if (this.menuSelection) {
                    if (this.n_selection) {
                        this.n_selection++;
                    }
                }
                break;
            case 'droite':
                if (this.waitForAcknowledge) {
                    this.acknowledge(true);
                } else if (this.menuSelection && this.status[this.n_selection]) {
                    this.menuSelection = false;
                    this.message = locales[this.locale].radio.statusSent;
                    this.sounds.acquit.play();
                    ModuleRP.radioSendStatus(this.vehicle.id, this.status[this.n_selection].code);
                }
                break;
            case 'gauche':
                if (this.waitForAcknowledge) {
                    this.acknowledge(false);
                } else {
                    this.init();
                }
                break;
            default:
                if (this.menuSelection) {
                    if (this.testNumericButtonForStatus) {
                        this.n_selection = parseInt(this.n_selection.toString() + button);
                    } else {
                        this.n_selection = parseInt(button);
                    }
                    this.testNumericButtonForStatus = true;
                    setTimeout(() => this.testNumericButtonForStatus = false, 2000);
                }
        }
        this.notifyListeners();
    };

    allumer = () => {
        this.on = true;
        this.message = locales[this.locale].radio.initialisation;
        this.sounds.start.play();
        this.notifyListeners();
        ModuleRP.allumerRadio(this.vehicle.id);
    };

    init = () => {
        this.n_selection = 1;
        this.menuSelection = false;
        this.message = locales[this.locale].radio.connected;
        this.sounds.start.play();
        setTimeout(() => this.sounds.start.pause(), 1500);
        this.notifyListeners();
    };

    loadStatus = () => {
        ModuleRP.listStatus.sort((a, b) => {
            return parseFloat(a.code) - (b.code);
        });
        ModuleRP.listStatus.forEach((status, index) => {
            status.selection = index;
            this.status[status.code] = status;
        });
        this.n_selection = 1;
        this.menuSelection = true;
        this.notifyListeners();
    };

    statusSent = (res) => {
        if (res === 'success') {
            this.message = locales[this.locale].radio.statusReceived;
            this.sounds.acquit_retour.play();
        } else {
            this.message = locales[this.locale].radio.transmissionFailed;
        }
        this.notifyListeners();
        setTimeout(() => this.init(), 2000);
    };

    newMessage = (message) => {
        this.waitForAcknowledge = true;
        this.message = translateEntries(message, this.locale);
        this.sounds.reception.play();
        this.sounds.reception.loop = true;
        this.notifyListeners();
    };

    acknowledge = (openStatus) => {
        this.waitForAcknowledge = false;
        this.sounds.reception.pause();
        if (openStatus) {
            this.loadStatus();
            ModuleRP.radioSendStatus(this.vehicle.id, 'ACK');
        } else {
            this.init();
        }
    };

    setLocale = (locale) => {
        this.locale = locale;
        this.notifyListeners();
    };
};
